module.exports = __webpack_public_path__ + "img/hello1.d007f125.png";